var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("BulkPayments.ViewHeader")))]),
      _vm._v(" "),
      _vm.legalEntities && _vm.legalEntities.length > 1
        ? _c(
            "div",
            { staticClass: "pr-5" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("select"), size: "mini" },
                  on: { change: _vm.onSelectedLegalEntityChanged },
                  model: {
                    value: _vm.selectedLegalEntity,
                    callback: function($$v) {
                      _vm.selectedLegalEntity = $$v
                    },
                    expression: "selectedLegalEntity"
                  }
                },
                _vm._l(_vm.legalEntities, function(legalEntity) {
                  return _c("el-option", {
                    key: legalEntity.reference,
                    attrs: {
                      label: `${legalEntity.registration_name}`,
                      value: legalEntity
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 30 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("BulkPayments.CreatedListHeader")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.loading,
                          data: _vm.createdBulkPayments
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.CreatedAt"),
                            "show-overflow-tooltip": "",
                            prop: "group_date",
                            formatter: _vm.formatDate,
                            width: "192"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.PaymentCount"),
                            "show-overflow-tooltip": "",
                            prop: "total_amount.aggregate.count",
                            width: "192"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.TotalAmount"),
                            "show-overflow-tooltip": "",
                            width: "192"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        scope.row.total_amount.aggregate.sum
                                          .amount !== null
                                          ? scope.row.total_amount.aggregate.sum.amount.toLocaleString(
                                              "nl-BE",
                                              {
                                                style: "currency",
                                                currency: "EUR"
                                              }
                                            )
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "show-overflow-tooltip": "", width: "192" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleOpenDetailsClick(
                                            scope.row.reference
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("BulkPayments.OpenDetails")
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { hidden: !_vm.paymentExecutorEnabled } },
                  [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("BulkPayments.ExecutedListHeader")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.loading,
                          data: _vm.excutedBulkPayments
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.CreatedAt"),
                            "show-overflow-tooltip": "",
                            prop: "created_at",
                            formatter: _vm.formatDate,
                            width: "192"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.PaymentCount"),
                            "show-overflow-tooltip": "",
                            prop: "details.total_amount.aggregate.count",
                            width: "192"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.TotalAmount"),
                            "show-overflow-tooltip": "",
                            width: "192"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        scope.row.details.total_amount.aggregate
                                          .sum.amount !== null
                                          ? scope.row.details.total_amount.aggregate.sum.amount.toLocaleString(
                                              "nl-BE",
                                              {
                                                style: "currency",
                                                currency: "EUR"
                                              }
                                            )
                                          : ""
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("BulkPayments.Status"),
                            "show-overflow-tooltip": "",
                            width: "192"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.determineBulkPaymentStatusDescription(
                                          scope.row
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "show-overflow-tooltip": "", width: "192" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        href: "test",
                                        size: "mini"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleOpenDetailsClick(
                                            scope.row.payment_transfer
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("BulkPayments.OpenDetails")
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { "show-overflow-tooltip": "", width: "192" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleOpenPaymentLink(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t("BulkPayments.signHere")
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }